import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { SqlPoolSink } from 'app/model/pipeline/copysink/sql-pool.copysink';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { SqlDWSinkAdapter, adapter } from './sqldw.sink.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlPoolSink),
    asynchronous: true,
    adapts: adapter
})
export class SqlPoolSinkAdapter extends CopySinkAdapter<SqlPoolSink, Model.SqlPoolSink> {
    protected override async _toResource(model: SqlPoolSink): Promise<Model.SqlPoolSink> {
        const result: Model.SqlPoolSink = {
            type: adfModelTypeMap.sqlPool.copySinkType
        };
        return SqlDWSinkAdapter.toResourceInternal(model, result, this.context);
    }

    protected override async _toModel(resource: Model.SqlPoolSink, owner: Activity): Promise<SqlPoolSink> {
        const result = Owned.create<SqlPoolSink>(Metamodel.modelFor(SqlPoolSink), owner);
        return SqlDWSinkAdapter.toModelInternal(resource, result);
    }
}
